// This file contains various position-related utility functions

import { Vector3, Spherical } from "three";

const BUFFER = 0.5; // needed to make objects "rooted" to the ground since we have a spherical world

// Gives you the equivalent x, y, z coordinates on a sphere given the sphere's radius
// and the theta/phi where you want to place the object
const sphericalToCartesian = (radius, phi, theta) => {
  return new Vector3().setFromSpherical(
    new Spherical(radius - BUFFER, phi, theta)
  );
};

export { sphericalToCartesian };
